<template lang="html">

  <section class="edit-datos-interes cover-edit">

    <div class="contenedor-popup row-center">

      <div class="popup-edit">

        <h2 class="titulo-popup" v-html="titulo"></h2>
        <p v-html="texto"></p>

        <div class="contenedor-botones row-start">

          <a class="btn -solid-primary" :loading="loading" @click="$emit('accept')">{{(!!textoaceptar) ? textoaceptar : 'Aceptar'}}</a>
          <a class="btn -skull-primary" @click="$emit('cancel')">{{(!!textorechazar) ? textorechazar : 'Cancelar'}}</a>

        </div>

      </div>

    </div>


  </section>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';


  export default  {
    name: 'confirm-popup',
    props : ['titulo','texto','textoaceptar','textorechazar','loading'],
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        style : 'getStyles',
      }),
    }
  }
</script>

<style scoped lang="scss">
.popup-edit {
  max-width: 600px;
}

.contenedor-botones{
  padding-left: 0;
  margin-top: 20px;
}

.titulo-popup{
  font-size: 24px;
  text-align: center;
  margin-bottom: 30px;
}

.contenedor-botones .btn{
  margin-left: 0;
}

.btn:first-of-type{
  margin-right: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/parts/confirm-popup.vue